export const FEATURE_FLAGS = {
  SETTINGS_FRONTEND_EMIS_CLOUD_ENABLED: 'SETTINGS_FRONTEND_EMIS_CLOUD_ENABLED',
  SETTINGS_FRONTEND_CUSTOM_CLOSURE_MESSAGE_ENABLED: 'SETTINGS_FRONTEND_CUSTOM_CLOSURE_MESSAGE_ENABLED',
  SMART_INBOX_NEW_ELITE: 'SMART_INBOX_NEW_ELITE',
  SMART_INBOX_REPORTING_ENABLED: 'SMART_INBOX_REPORTING_ENABLED',
  SCHEDULED_CLOSURE_TYPE_ENABLED: 'SETTINGS_FRONTEND_SCHEDULED_CLOSURE_TYPE_ENABLED',
  CONSULTATION_RESPONSE_TIME_ENABLED: 'SETTINGS_CONSULTATION_RESPONSE_TIME_ENABLED',
  SETTINGS_CONSULTATION_RESPONSE_TIME_USER_EDITABLE: 'SETTINGS_CONSULTATION_RESPONSE_TIME_USER_EDITABLE',
  CUSTOM_LANDING_PAGE_MESSAGE_ENABLED: 'SETTINGS_CUSTOM_LANDING_PAGE_MESSAGE_ENABLED',
  PRACTICE_USER_ROLES_ENABLED: 'USER_MANAGEMENT_PRACTICE_USER_ROLES_ENABLED',
  SETTINGS_CLOSING_TIME_BEHAVIOUR_ENABLED: 'SETTINGS_CLOSING_TIME_BEHAVIOUR_ENABLED',
  DEMAND_MANAGEMENT_ENABLED: 'DEMAND_MANAGEMENT_ENABLED',
  DEFAULT_CUSTOM_CLOSURE_MESSAGE_TOGGLE_ENABLED: 'SETTINGS_FRONTEND_DEFAULT_CUSTOM_CLOSURE_MESSAGE_TOGGLE_ENABLED',
};
